import React, { FC, useEffect } from "react";
import styled from "@emotion/styled";
import { UserOutlined } from "@ant-design/icons";
import { Col, Row, Spin } from "antd";
import ReactApexcharts from "react-apexcharts";

import { ApexOptions } from "apexcharts";
import { GetFactoryIncomeChartData } from "services/interface";
import { numberFormat, stringWithCommaFormat } from "utils/nuberFormat";
import { set } from "lodash";

interface ContentBodyProp {
  data: GetFactoryIncomeChartData[] | undefined;
  isLoading: boolean;
  selectYear: number;
  daterangePicker: [string,string]
}

const colorData = ["#787eff", "#83e542", "#fdbe42", "#40cdfa", "#ff625f","#e73ce7"];

const ContentBody: FC<ContentBodyProp> = ({ data, isLoading, selectYear , daterangePicker}) => {
  const [series, setSeries] = React.useState<ApexAxisChartSeries>([]);
  const [categories, setCategories] = React.useState<string[]>([]);
  const [colors, setColors] = React.useState<string[]>([]);

  const [loading, setLoading] = React.useState<boolean>(isLoading);

  // const series : ApexAxisChartSeries = [
  //   {
  //     data: [280, 200, 220, 180, 270, 250, 70, 90, 200, 150, 160, 100, 150, 100, 50],
  //     name: 'ยอดขาย',

  //   },
  //   {
  //     data: [80, 50, 60, 10, 15, 10, 5, 28, 20, 20, 18, 27, 25, 7, 9],
  //     name: 'ยกเลิก'
  //   }
  // ]

  useEffect(() => {
    if (data != undefined && data?.length > 0 && !isLoading && data != null) {
      const categories = data[0].month_list.map((item) => item.short_name);
      const series: ApexAxisChartSeries = data.map((item) => {
        return {
          name: item.name,
          data: item.month_list.map((month) => month.value),
        };
      });

      const colors = data.map((item, index) => {
        return colorData[index];
      });

      setCategories(categories);
      setSeries(series);
      setColors(colors);
    }
  }, [data]);

  const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

  const onChangeDelay = async () => {
    setLoading(true);
    await delay(1000);
    setLoading(false);
  };

  useEffect(() => {
    onChangeDelay();
  }, [daterangePicker]);

  const options: ApexOptions = {
    chart: {
      parentHeightOffset: 0,
      zoom: { enabled: false },
      toolbar: { show: false },
    },
    colors: colors,
    stroke: { curve: "smooth" },
    dataLabels: { 
      enabled: true,  
      formatter: (val:number) => `฿${numberFormat(val)}`,
     },
    markers: {
      strokeWidth: 7,
      strokeOpacity: 1,
      colors: colors,
      strokeColors: ["#fff"],
    },
    states: {
      hover: {
        filter: { type: "none" },
      },
      active: {
        filter: { type: "none" },
      },
    },
    legend: {
      position: "top",
      onItemClick: {
        toggleDataSeries: true,
      },
    },
    // tooltip: {
    //   custom(data: any) {
    //     return `<div class='bar-chart'>
    //       <span>${data.series[data.seriesIndex][data.dataPointIndex]}%</span>
    //     </div>`
    //   }
    // },

    xaxis: {
      axisBorder: { show: false },
      categories: categories,
      labels: {
        formatter: (val) => `฿${stringWithCommaFormat(val)}`,
        style: {
          fontWeight: 600,
          fontSize: "0.875rem",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontWeight: 600,
          fontSize: "0.875rem",
        },
        formatter: (val) => `฿${numberFormat(val)}`,
      },
    },
  };

  return (
    <>
      {loading ? (
        <Spin>
          <ReactApexcharts
            type="line"
            height={250}
            options={options}
            series={series}
          />
        </Spin>
      ) : (
        <ReactApexcharts
          type="line"
          height={250}
          options={options}
          series={series}
        />
      )}
    </>
  );
};

export default ContentBody;

const WrapperCardGraph = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background-color: #efefef;
  padding: 10px;
  height: 500px;
  width: 100%;
`;
